import { ScrapHighlightNode } from './ScrapHighlightNode'
import { SearchKeywordHighlightNode } from './SearchKeywordHighlightNode'

export * from './ScrapHighlightNode'

export * from './SearchKeywordHighlightNode'

export enum CoverLetterNodeType {
  COMPONENT,
  NATIVE_NODE,
  TEXT_NODE,
}

export interface CoverLetterContentNode {
  id: string
  type: CoverLetterNodeType
  wrapper?: string
  childrenNodeList: CoverLetterContentNode[]
  text?: string
}

export function getCoverLetterContentWrapperComponentByName(name: string): any {
  switch (name) {
    case 'ScrapHighlightNode': {
      return ScrapHighlightNode
    }
    case 'SearchKeywordHighlightNode': {
      return SearchKeywordHighlightNode
    }
    default: {
      return null
    }
  }
}

export function buildTextNode(
  id: string,
  text: string,
): CoverLetterContentNode {
  return {
    id,
    type: CoverLetterNodeType.TEXT_NODE,
    childrenNodeList: [],
    text,
  }
}
